<template>
    <div>
        <h1 class="text-center">
            Coming Soon!
        </h1>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>